import { BlurView } from 'expo-blur'
import { LinearGradient } from 'expo-linear-gradient'
import { View, Text } from 'react-native'
import { cardImageStyle } from '@/src/app/main/(tabs)/card/card-management/virtual-card/cardImageStyle'
import { CreditCardIcon } from '@/src/assets/icons/CreditCard'
import { mesaColorNames, typography } from '@/src/common/theme'

export function CardHasShipped() {
  return (
    <View
      style={[
        cardImageStyle,
        {
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        },
      ]}
    >
      <View style={{ opacity: 0.92, height: '100%', width: '100%', position: 'absolute' }}>
        <BlurView
          intensity={8}
          style={{ height: '100%', width: '100%', position: 'absolute' }}
          experimentalBlurMethod="dimezisBlurView"
        />
        <LinearGradient
          colors={[
            `${mesaColorNames['Mesa - Brand/Secondary #223843']}00`,
            `${mesaColorNames['Greyscale/900 #152438']}75`,
            mesaColorNames['Greyscale/900 #152438'],
          ]}
          locations={[0, 0.45, 1]}
          style={{ height: '100%', width: '100%', position: 'absolute' }}
        />
      </View>
      <View style={{ display: 'flex', flexDirection: 'row', gap: 4, alignItems: 'flex-start' }}>
        <CreditCardIcon height={18} />
        <View style={{ display: 'flex', flexDirection: 'column', width: 287 }}>
          <Text
            style={[typography['XS Bold'], { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] }]}
          >
            Your Mesa Homeowners Card has shipped!
          </Text>
          <Text style={[typography.XS, { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] }]}>
            Once your Mesa Homeowners Card arrives, return here to activate it then connect an
            external account to manage your card directly in-app.
          </Text>
        </View>
      </View>
    </View>
  )
}
